import { module } from 'angular';
import templateBuilderTextAreaDisplay from './builder/display.html';
import templateBuilderTextAreaData from './builder/data.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/textarea/display.html', templateBuilderTextAreaDisplay);
	$templateCache.put('kform/components/textarea/data.html', templateBuilderTextAreaData);
});
